import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ReferralReportsAdapter } from '@modules/reports/models/referral-reports-item';
import { AssociationLabel, CandidateAdapter } from '@shared';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { candidatesGet, getCandidate } from '@collections/candidates';
import { IsMobileViewService } from '@shared/services/is-mobile-view.service';

@Component({
  selector: 'mojo-referral-reports-list-item',
  styleUrls: ['./referral-reports-list-item.component.scss'],
  templateUrl: './referral-reports-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralReportsListItemComponent implements OnInit {
  @Input()
  referralReportItem: ReferralReportsAdapter;

  @Input()
  showBy = 'Job';

  associationLabel = JSON.stringify(AssociationLabel.DIRECT);

  candidate$: Observable<CandidateAdapter>;

  constructor(private store: Store<{}>, public isMobileViewService: IsMobileViewService) {}

  ngOnInit(): void {
    this.store.dispatch(candidatesGet({ id: this.referralReportItem.candidateId }));
    this.candidate$ = this.store.select(getCandidate(this.referralReportItem.candidateId));
  }
}
